import React, { useEffect, useState } from "react";

import { loadStripe } from "@stripe/stripe-js";
import {
  Elements,
  CardElement,
  useStripe,
  useElements,
} from "@stripe/react-stripe-js";
import { STRIPE_PUBLISHABLE_KEY } from "../utils/env";

const stripePromise = loadStripe(STRIPE_PUBLISHABLE_KEY);

interface PaymentCardType {
  setCardElement: Function;
}

const StripePaymentCard: React.FC<PaymentCardType> = ({ setCardElement }) => {
  const stripe = useStripe();
  const elements = useElements();

  useEffect(() => {
    if (stripe && elements) {
      const cardElement = elements.getElement(CardElement);

      setCardElement(stripe, cardElement);
    }
  }, [stripe, elements]);

  return (
    <>
      <div className="form-group">
        <div className="form-control">
          <CardElement options={{ style: { base: { fontSize: "16px" } } }} />
        </div>
      </div>
    </>
  );
};

const StripePaymentElement: React.FC<PaymentCardType> = ({
  setCardElement,
}) => {
  return (
    <Elements stripe={stripePromise}>
      <div className="stripe-payment-wrapper">
        <StripePaymentCard setCardElement={setCardElement} />
      </div>
    </Elements>
  );
};

export default StripePaymentElement;
